import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_entity_merging_processing_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  master_guid: fromDatatype.GuidDataFieldInterface;
  old_guids_json: fromDatatype.VarcharArrayDatatypeInterface;
  successfully_merged_entity: fromDatatype.IntegerDatatypeInterface;
  total_entity_to_be_meged: fromDatatype.IntegerDatatypeInterface;
  merge_status: fromDatatype.VarcharDatatypeInterface;
  entity_type: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_mst_entity_merging_processing_RowClass
  implements bl_fi_mst_entity_merging_processing_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  master_guid: fromDatatype.GuidDataFieldInterface;
  old_guids_json: fromDatatype.VarcharArrayDatatypeInterface;
  successfully_merged_entity: fromDatatype.IntegerDatatypeInterface;
  total_entity_to_be_meged: fromDatatype.IntegerDatatypeInterface;
  merge_status: fromDatatype.VarcharDatatypeInterface;
  entity_type: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.RevisionDataFieldInterface;
}
